import ReflectionCompletionRateComparisonBarCharts from 'widgets/ReflectionCompletionRateComparisonBarCharts/ReflectionCompletionRateComparisonBarCharts'

export default ReflectionCompletionRateComparisonBarCharts
